import { render, staticRenderFns } from "./settingPortal3.vue?vue&type=template&id=dd057e9c&scoped=true&"
import script from "./settingPortal3.vue?vue&type=script&lang=js&"
export * from "./settingPortal3.vue?vue&type=script&lang=js&"
import style0 from "./settingPortal3.vue?vue&type=style&index=0&id=dd057e9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd057e9c",
  null
  
)

export default component.exports